// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contrast [type=radio].with-gap:checked+span[data-v-4bb069f6]:after,.contrast [type=radio]:checked+span[data-v-4bb069f6]:after{background-color:#fff!important}.contrast [type=radio].with-gap:checked+span[data-v-4bb069f6]:after,.contrast [type=radio].with-gap:checked+span[data-v-4bb069f6]:before,.contrast [type=radio]:checked+span[data-v-4bb069f6]:after{border-color:#fff}", ""]);
// Exports
module.exports = exports;
